<template>
  <div class="align-self-end" >
    <b-button style="border: 2px black!important"  type="button" class="btn-carouse btn-custom" @click="postbackClick"> <a>{{ content.title }}</a></b-button>
  </div>
</template>
<script>
import EventBus from "@/functions/EventBus";
export default {
  props: ["content"],
  data() {
    return {};
  },
  computed: {
    isWebUrl: function() {
      return this.content.type === "web_url";
    },
    isPostback: function() {
      return this.content.type === "postback";
    },
    isPhoneCall: function() {
      return this.content.type === "phone_number";
    },
    isText: function() {
      return this.content.content_type === "text";
    }
  },
  methods: {
    postbackClick() {
      // TODO: send payload to chathub
      if (this.isWebUrl) {
        window.open(this.content.url);
      } else if (this.isPostback) {
        console.log("Simulate send payload to chathub");
        EventBus.$emit("postback-clicked", {
          payload: this.content.payload
        });
      } else if (this.isPhoneCall) {
        console.log("Simulate phone call");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-carouse {
  font-family: inherit !important;
  background-color: white;
  width: 100%;
  height: 30px;
  padding: 3px 20px;
  color: black !important;
  border: black !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  outline: none;
}
.btn-custom {
  border-top: 2px black!important;
  &:focus {
    box-shadow: none !important;
  }
  background: #fff;
    color: #0084ff !important;
    
    &:hover {
        // background: #fff !important;
        color: #fff !important;
    }

}



      
</style>